import React, { useState } from 'react';
import { Text, Checkbox } from 'components';
import { INotificationSettings } from '@bb/users';
import type { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { cloneDeep } from 'lodash';
import { StyledModal, StyledModalWidth } from './constants';

type UnsubscribeAllProps = {
  notifications: INotificationSettings;
  setModifiedNotifications: React.Dispatch<
    React.SetStateAction<INotificationSettings>
  >;
};

const UNSUBSCRIBE_FIELDS: (keyof Pick<
  INotificationSettings,
  | 'instant'
  | 'dailyOpenHouse'
  | 'dailyNewListings'
  | 'dailyNeeds'
  | 'weeklyUpdate'
>)[] = [
  'instant',
  'dailyOpenHouse',
  'dailyNewListings',
  'dailyNeeds',
  'weeklyUpdate',
];

const UnsubscribeAll: React.FC<UnsubscribeAllProps> = ({
  notifications,
  setModifiedNotifications,
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const isUnsubscribedAll = UNSUBSCRIBE_FIELDS.every(key => {
    const field = notifications[key];

    if (key === 'instant') {
      return Object.values(field).every(x => !x);
    }

    return !field;
  });

  const onChange = ({ target: { checked } }: CheckboxChangeEvent) => {
    if (!checked) return;

    setConfirmOpen(true);
  };

  const onOk = () => {
    const newNotifications = cloneDeep(notifications);

    UNSUBSCRIBE_FIELDS.forEach(key => {
      if (key === 'instant') {
        Object.keys(newNotifications.instant).forEach(
          (x: keyof typeof newNotifications.instant) => {
            newNotifications.instant[x] = false;
          },
        );
      } else {
        newNotifications[key] = false;
      }
    });

    setModifiedNotifications(newNotifications);
    setConfirmOpen(false);
  };

  return (
    <>
      <Checkbox
        key={'unsubscribe-all'}
        data-cy={'unsubscribe-all'}
        checked={isUnsubscribedAll}
        onChange={onChange}
      >
        Unsubscribe from all notifications
      </Checkbox>

      <StyledModal
        title="Unsubscribe from all Notifications"
        width={StyledModalWidth}
        open={confirmOpen}
        onCancel={() => setConfirmOpen(false)}
        okText="Unsubscribe"
        onOk={onOk}
      >
        <Text>
          You will be unsubscribing from all notifications from BrokerBay. This
          includes instant updates, daily recaps and weekly recaps.
        </Text>
      </StyledModal>
    </>
  );
};

export default UnsubscribeAll;
